import { Wrapper } from '../assets/Wrappers/FriendsLogo'

const FriendsLogo = () => {
  return (
    <Wrapper>
      F
      <span className='dot red'>
        .
      </span>
      R
      <span className='dot blue'>
        .
      </span>
      I
      <span className='dot yellow'>
        .
      </span>
      E
      <span className='dot red'>
        .
      </span>
      N
      <span className='dot yellow'>
        .
      </span>
      D
      <span className='dot blue'>
        .
      </span>
      S
      <span className='dot yellow'>
        .
      </span>
    </Wrapper>
  )
}

export default FriendsLogo
